var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseIcon = function SvgPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#D0006F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.117 24h-5.293a.356.356 0 0 0-.355.356v23.288c0 .197.159.356.355.356h5.293c.197 0 .356-.16.356-.356V24.356a.356.356 0 0 0-.356-.356M34.649 24h-5.293a.356.356 0 0 0-.356.356v23.288c0 .197.16.356.356.356h5.292c.197 0 .356-.16.356-.356V24.356A.356.356 0 0 0 34.65 24"
  })));
};
export default SvgPauseIcon;